import axios from "./axios-handler.service";

const BASE_URL = "/api/DashboardVendedor";

export interface DashboardVendedorFiltro {
  idVendedor: number;
  mesAno: string;
}

export interface DashboardVendedorNivel {
  idNivelAtual: number;
  nivelAtual: string;
  valorBonus: number;
  valorProximoBonus: number;
  progressoPercentual: number;
  pontosAtuais: number;
  pontosBaseAtual: number;
  pontosProximoNivel: number;
  proximoNivel: string;
}

export interface DashboardVendedorResumoPlano {
  plano: string;
  quantidade: number;
  pontos: number;
}

export interface DashboardVendedorResumoVendas {
  itens: DashboardVendedorResumoPlano[];
  quantidadeTotal: number;
  pontosTotal: number;
}

export interface DashboardVendedorUltimaVenda {
  idPlano: number;
  idConsultor: number;
  data: string;
  idTipoPlano: number;
  plano: string;
  consultor: string;
  pontos: number;
  status: number;
  descricaoStatus: string;
}

export interface DashboardVendedorRankingItem {
  idUsuario: number;
  nome: string;
  nivel: string;
  pontos: number;
  posicao: number;
}

export interface DashboardVendedorDados {
  dataFechamento: string;
  metaAtual: DashboardVendedorMetaAtual | null;
  nivelAtual: DashboardVendedorNivel;
  resumoVendas: DashboardVendedorResumoVendas;
  ultimasVendas: DashboardVendedorUltimaVenda[];
  ranking: DashboardVendedorRankingItem[];
  niveis: NivelBonificacao[];
}

export interface FechamentoVendedorRelatorioItem {
  nomeVendedor: string;
  dataFechamento: string;
  bonificacaoMeta: number;
  bonificacaoNivel: number;
  bonificacaoTotal: number;
  totalPontos: number;
  posicaoRanking: number;
}

export interface DashboardVendedorMetaAtual {
  metaAtual: number;
  metaDiaria: number;
  pontuacaoHoje: number;
  valorBonus: number;
  percentual: number;
  projecao: number;
  mensagem: string;
}

export interface NivelBonificacao {
  nome: string;
  bonus: number;
  pontos: number;
}

export class DashboardVendedorService {
  static async ObterDashboard(
    filtro: DashboardVendedorFiltro,
  ): Promise<DashboardVendedorDados> {
    const { idVendedor, mesAno } = filtro;

    const response = await axios.get<DashboardVendedorDados>(
      `${BASE_URL}/Obter`,
      {
        params: { idVendedor, mesAno },
      },
    );

    return response.data;
  }

  static async ObterRelatorioFechamento(
    mesAno: string,
  ): Promise<FechamentoVendedorRelatorioItem[]> {
    const response = await axios.get<FechamentoVendedorRelatorioItem[]>(
      `${BASE_URL}/RelatorioFechamento`,
      {
        params: { mesAno },
      },
    );

    return response.data;
  }
}
